/* eslint-disable */
import { FC } from 'react';
import { useHistory } from 'react-router';
import { useGetFlow } from '~/controllers/wizard';
import paths from '~/pages/paths';
import { auth } from '~/api/auth';
import { isAgent, isNogoManager, isSales } from '~/utils/getDecodedJwt';

const HomeScreen: FC<void> = () => {
  const history = useHistory();
  // const shouldGoToDashboard = getShouldGoToDashboard();

  // console.log(`shouldGoToDashboard=${shouldGoToDashboard}`);
  const currentApplication = auth.getAgentApplicationId();

  if (isAgent() || isNogoManager()) {
    if (currentApplication) {
      history.push(paths.home.application);
    } else {
      history.push(paths.agent._);
    }
  } else if (isSales()) {
    history.push(paths.sales._);
  } else {
    useGetFlow({
      onSuccess(data) {
        if (data[0].applicationId) {
          history.push(paths.home.application);
        } else if (data?.[0]?.flowType === 'KSA_ONBOARDING_INVITATION') {
          history.push(paths.ksa.invitation._);
        } else {
          history.push(paths.ksa._);
        }
      },
      staleTime: undefined,
      enabled: true,
    });
  }

  return null;
};

export default HomeScreen;
